export default "__VITE_ASSET__jFNo_a1R__"